import React, { forwardRef, useImperativeHandle } from 'react'
import {
  Snackbar,
  Slide,
  Card,
  Button,
  ThemeProvider,
  StyledEngineProvider,
} from '@mui/material'
import Typography from '../Typography/Typography'
import {
  CheckCircle as CheckCircleIcon,
  Warning as WarningIcon,
  Error as ErrorIcon,
  Info as InfoIcon,
} from '@mui/icons-material'
import ThemeConfig from '../../theme/ThemeConfig'

const TransitionRight = props => {
  return <Slide {...props} direction="left" />
}

const iconStyles = {
  color: 'white',
  paddingLeft: '7px',
  marginTop: '2.5rem',
}

const styles = {
  success: {
    backgroundColor: '#008300',
    icon: <CheckCircleIcon style={iconStyles} />,
  },
  error: {
    backgroundColor: '#CC0000',
    icon: <WarningIcon style={iconStyles} />,
  },
  warning: {
    backgroundColor: '#ff9800',
    icon: <ErrorIcon style={iconStyles} />,
  },
  info: { backgroundColor: '#2196f3', icon: <InfoIcon style={iconStyles} /> },
}

const getAutoHideDuration = (dismissButton, autoHideDuration) => {
  if (
    autoHideDuration === undefined || // no duration defined
    (autoHideDuration === null && !dismissButton) || // duration was chosen as null but no dismissButton is shown
    (autoHideDuration !== null && autoHideDuration < 1000) // or it's extremely short
  ) {
    return 3200
  }

  return autoHideDuration
}

const SimpleSnackbar = forwardRef((props, ref) => {
  const [open, setOpen] = React.useState(false)
  const { type: snackBarType, message, dismissButton, autoHideDuration } = props

  useImperativeHandle(ref, () => ({
    handleClick: () => {
      setOpen(true)
    },
  }))

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return
    }

    setOpen(false)
  }

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={ThemeConfig}>
        <Snackbar
          style={{ position: 'unset', paddingTop: '.5rem' }}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          open={open}
          onClose={handleClose}
          autoHideDuration={getAutoHideDuration(
            dismissButton,
            autoHideDuration,
          )}
          TransitionComponent={TransitionRight}
        >
          <Card
            style={{
              background: `linear-gradient(to right, ${
                styles[`${snackBarType}`].backgroundColor
              } 0%, ${
                styles[`${snackBarType}`].backgroundColor
              } 10%, white 10%, white 100%)`,
              width: '24.125rem',
            }}
          >
            <div style={{ display: 'table', width: '100%', height: '100%' }}>
              <div style={{ float: 'left', width: '15%' }}>
                {styles[`${snackBarType}`].icon}
              </div>
              <div style={{ float: 'left', width: '80%' }}>
                <Typography
                  style={{
                    fontFamily: ThemeConfig.typography.fontFamily,
                    fontWeight: ThemeConfig.typography.h2.fontWeight,
                    fontSize: 20,
                  }}
                >
                  {snackBarType.charAt(0).toUpperCase() + snackBarType.slice(1)}
                </Typography>

                <Typography
                  style={{ fontFamily: ThemeConfig.typography.fontFamily }}
                >
                  {message}
                </Typography>
              </div>
            </div>

            {dismissButton && (
              <Button
                onClick={handleClose}
                color="primary"
                style={{ display: 'block', marginLeft: '18.5rem' }}
              >
                DISMISS
              </Button>
            )}
          </Card>
        </Snackbar>
      </ThemeProvider>
    </StyledEngineProvider>
  )
})
export default SimpleSnackbar
